import { useEffect } from 'react';
import get from 'lodash/get';

import { userSettingsByKeySelector } from 'store/selectors/userSelectors';
import { useTypedSelector } from 'hooks/useTypedSelector';
import { THEME } from 'utils/constants/wordsConstants';
import { EThemes } from 'types/commonEnums';

import { antdDarkTheme, antdLightTheme, themeDark, themeLight } from 'ThemeStyles';

const stylesByTheme = { [EThemes.Light]: themeLight, [EThemes.Dark]: themeDark };
const antdByTheme = { [EThemes.Light]: antdLightTheme, [EThemes.Dark]: antdDarkTheme };

export default function() {
  const theme = useTypedSelector((state) => userSettingsByKeySelector({ key: THEME, ...state }));

  useEffect(() => {
    document.body.setAttribute(THEME, theme);
  }, [theme]);

  return { stylesTheme: get(stylesByTheme, theme), antdTheme: get(antdByTheme, theme) };
}
